import React from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import { Link, useLoaderData } from "react-router-dom";
import "./TutorPayment.css";

const RequestRefoundDetails = () => {
  const data = useLoaderData();

  const Invoice = data._id;
  const InvoiceId = Invoice.slice(-6);

  console.log("data", data);

  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleButtonClick = (data) => {
    setSelectedItem(data);
    setIsOpen(!isOpen);
  };
  const [inputNumber, setInputNumber] = useState("");
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [refundReason, setRefundReason] = useState("");

  const handleClassBooked = (id, inputNumber, selectedPaymentMethod) => {
    fetch(`https://tutor-tree-server-1.vercel.app/shortlistedMainData/refunds/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        inputNumber: inputNumber,
        paymentMethod: selectedPaymentMethod,
        refundReason: refundReason,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("Sent invoice Successful.");
          // Re-fetch the updated user data
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };

  const handlePrint = () => {
    const printContents = document.getElementById("admissionForm").innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };
  return (
    <div className="pb-10">
      <div className="w-full h-32 flex justify-center items-center bg-gray-50">
        <h2 className="headingTxt">All Invoice / Pending Payment</h2>
      </div>

      <div id="admissionForm" className="px-10">
        <div className="flex items-center justify-between py-5  border-b-2 border-gray-200">
          <div>
            <h1 className="headingText">Payment Due</h1>
          </div>
          {/* <div><h1 className='headingTextLink'>Back</h1></div> */}
        </div>
        <div className="flex items-center justify-between py-5">
          <div>
            <h1 className="Invoice">
              Invoice : <span className="jobDetails">{InvoiceId}</span>
            </h1>
            <h1 className="Invoice mt-3">
              Last Date :<span className="jobDetails">{data.EndDate}</span>{" "}
            </h1>
          </div>
          <div className="print:hidden">
            <Link to={`/dashboardTwo/AllInvoiceJobDetails/${data._id}`}>
              <h1 className="tutorDetails">Job Details</h1>
            </Link>
            <button onClick={handlePrint}>
              <h1 className="tutorDetails mt-3">Download</h1>
            </button>
          </div>
        </div>
        <div className="flex lg:items-center lg:flex-row sm:flex-col lg:justify-between mt-5">
          <div>
            <h1 className="billedTo">Billed To :</h1>
            <h1 className="Invoice mt-5">
              Name : <span className="invoicePera">{data.teacherName}</span>
            </h1>
            <h1 className="Invoice mt-3">
              Address :{" "}
              <span className="invoicePera">
                {data.teachercity} {data.teacherarea}
              </span>{" "}
            </h1>
            <h1 className="Invoice mt-3">
              Phone : <span className="invoicePera">{data.teacherPhone}</span>{" "}
            </h1>
          </div>
          <div className="sm:mt-5">
            <h1 className="billedTo">From</h1>
            <h1 className="InvoicePera mt-5">Teacher Today</h1>
            <h1 className="InvoicePera mt-3">Sugandha, Panchlaish</h1>
            <h1 className="InvoicePera mt-3">teacherstoday.ctg@gmail.com</h1>
          </div>
        </div>
        <div className="w-full bg-gray-100 h-10 flex justify-end items-center mt-5">
          <h1 className="textAmount mr-3">Amount </h1>
        </div>
        <div className="w-full h-10 flex justify-between items-center mt-5">
          <h1 className="textAmount">Job Id: {data.StudentsJobID}</h1>
          <h1 className="textAmount mr-3">{data.inputData} tk</h1>
        </div>
        <div className="w-full h-10 flex justify-end items-center mt-5">
          <h1 className="textAmountTotal mr-3">Total: {data.inputData} tk</h1>
        </div>
        <div className="flex flex-col justify-start">
          <h1>
            Pay To: <span className="paidPera"> 01629964650</span>
          </h1>
          <div className="flex flex-col justify-start mt-3">
            <div className="flex flex-row w-full items-center ">
              <div className="w-32">
                <h1 className="Paid">Paid From:</h1>
              </div>
              <input
                type="text"
                id="default-input"
                value={inputNumber}
                onChange={(e) => setInputNumber(e.target.value)}
                class="bg-gray-50 border border-gray-300 ml-3 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-40 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              />
            </div>
            <div className="flex justify-between lg:flex-row sm:flex-col">
              <div className="flex flex-row items-center mt-3 w-84">
                <div className="w-full">
                  <h1 className="Paid">Payment Method:</h1>
                </div>
                <select
                  className="select select-bordered w-40 ml-3"
                  value={selectedPaymentMethod}
                  onChange={(e) => setSelectedPaymentMethod(e.target.value)}
                >
                  <option disabled value="">
                    Select
                  </option>
                  <option value="BKash">BKash</option>
                  <option value="Nagad">Nagad</option>
                  <option value="Rocket">Rocket</option>
                  <option value="Cash">Cash</option>
                </select>
              </div>
            </div>
            <div className="flex justify-between lg:flex-row sm:flex-col mt-5">
              <div className="flex flex-col  mt-3 w-full pr-10">
                <div>
                  <h1 className="RefundText">Refund Reason</h1>
                </div>
                <div className="mt-3">
                  <textarea
                    value={refundReason}
                    onChange={(e) => setRefundReason(e.target.value)}
                    className="textarea textarea-bordered w-full h-28"
                    placeholder="Bio"
                  ></textarea>
                </div>
                <div className="flex flex-row justify-end mt-3 sm:mt-5 print:hidden">
                  <div className="flex flex-col">
                    <button
                      onClick={() =>
                        handleClassBooked(
                          data._id,
                          inputNumber,
                          selectedPaymentMethod
                        )
                      }
                      className="buttonSent"
                    >
                      Submit
                    </button>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isOpen && selectedItem && (
        <div className="container max-w-[1000px] mx-auto">
          <div className="contentApplication bg-white rounded-xl py-5 border border-gray-200">
            <div className="flex flex-row  justify-between px-10 ">
              <div>
                <h1 className="modalTittleAppli">Tutor Details</h1>
              </div>
              <div className="justify-end">
                <div>
                  <div className="flex justify-end items-center">
                    <button
                      onClick={() => setIsOpen(false)}
                      className="w-8 h-8 rounded-full flex justify-center items-center bg-orange-300 hover:bg-orange-400"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <hr className="h-2 mt-10 w-full"></hr>

            {/* Display data from selectedItem in the modal */}
            <div className="px-10">
              <div className="w-full">
                <h1 className="text-right download">Download</h1>
              </div>
              <div className="h-[600px] overflow-y-auto">
                <div className="rounded-lg border-2 mt-5">
                  <div className="px-5 py-3 flex justify-between items-center">
                    <h1 className="applicationModalOne">
                      Personal Information
                    </h1>
                  </div>
                  <hr className="h-2"></hr>
                  <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Name :</span> Md Jahidul
                        Islam
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Gender :</span> Male
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Religion:</span> Islam
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Phone :</span>{" "}
                        01684858866
                      </h1>
                    </div>

                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">City :</span> Dhaka
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Area :</span>{" "}
                        Mohammadpur
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera"></span>NID / Birth
                        Certificate / Passport :
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Emergency :</span>{" "}
                        01684858866
                      </h1>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg border-2 mt-5">
                  <div className="px-5 py-3 flex justify-between items-center">
                    <h1 className="applicationModalOne">
                      Educational Information
                    </h1>
                  </div>
                  <hr className="h-2"></hr>
                  <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">
                          Level of Education :
                        </span>
                        Honors/Diploma
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Institute :</span> UIU
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Certificate :</span>{" "}
                        Islam
                      </h1>
                    </div>

                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Semester/Year :</span>{" "}
                        12th{" "}
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Major/Subject :</span>{" "}
                        CSE
                      </h1>
                    </div>
                  </div>
                  <hr className="h-2 mt-3 mx-5"></hr>
                  <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">
                          Level of Education :
                        </span>
                        Honors/Diploma
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Institute :</span> UIU
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Certificate :</span>{" "}
                        Islam
                      </h1>
                    </div>

                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Group :</span> 12th{" "}
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Passing Result :</span>
                        A+
                      </h1>
                    </div>
                  </div>
                  <hr className="h-2 mt-3 mx-5"></hr>
                  <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">
                          Level of Education :
                        </span>
                        Honors/Diploma
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Institute :</span> UIU
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Certificate :</span>{" "}
                        Islam
                      </h1>
                    </div>

                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Group :</span> 12th{" "}
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Passing Result :</span>
                        A+
                      </h1>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg border-2 mt-5">
                  <div className="px-5 py-3 flex justify-between items-center">
                    <h1 className="applicationModalOne">Teaching Experience</h1>
                  </div>
                  <hr className="h-2"></hr>
                  <div className="px-5 py-4">
                    <p className="peraText">
                      Lorem ipsum dolor sit amet consectetur. Urna porttitor
                      amet in facilisis. Vitae congue egestas pretium cursus
                      nulla. Ridiculus ornare pellentesque facilisis cras
                      hendrerit porttitor luctus turpis. Posuere neque quis leo
                      molestie dui quis nisl. Blandit amet amet nunc ut
                      condimentum nisl in amet. Vitae odio sagittis sollicitudin
                      duis ornare felis aliquam adipiscing. Auctor turpis
                      pharetra faucibus urna mauris at nisl molestie. Sit sem
                      amet faucibus sed at. Nunc dignissim imperdiet commodo in
                      nam id elit eu pellentesque. Faucibus vel vivamus volutpat
                      nulla. Velit orci placerat vel in risus vestibulum. Diam
                      lacus amet nibh cursus vel convallis. Orci adipiscing quam
                      nisi faucibus lobortis lorem magna vestibulum tempus.
                      Mauris euismod venenatis feugiat ligula non tellus amet a
                      elementum. Eget ac dictum commodo rhoncus amet quis dui
                      massa blandit. Turpis id donec morbi in sit ac. Blandit
                      quam gravida placerat conse
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Add more elements to display other properties */}
          </div>
        </div>
      )}
    </div>
  );
};

export default RequestRefoundDetails;
